<template>
    <div class="container tile">
        <div v-if="offlineContent" v-html="offlineContent" />
        <div class="col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 p-4" v-else>
            <div class="alert alert-secondary text-center">This page is unavailable at this time.</div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { usePageStore } from "../pageState/store";
export default defineComponent({
    setup() {
        const pageStore = usePageStore();
        return {
            isOffline: computed(() => pageStore.isOffline),
            offlineContent: computed(() => pageStore.offlineContent),
        };
    },
});
</script>
